<template>
    <div class="GRXX">
        <div class="f1">
            <div class="title">
                <span>个人信息</span>
            </div>
            <div class="updata" @click="goUpdata('修改信息')">
                <span
                    style="font-size: 20px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #6681EA;">修改个人信息</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="info">
                <div class="infoCover">
                    <img :src="userInfo.cover ? userInfo.cover : cover" style="width: 140px;height: auto;" fit="cover">
                </div>
                <div class="details">
                    <div class="detail">
                        <span>认证名字：</span>
                        <span>{{ userInfo.name }}</span>
                    </div>
                    <div class="detail">
                        <span>身份证号码：</span>
                        <span>{{ userInfo.idcard }}</span>
                    </div>
                    <div class="detail">
                        <span>性别：</span>
                        <span>{{ userInfo.sex == 1 ? '女' : '男' }}</span>
                    </div>
                    <div class="detail">
                        <span>手机号码：</span>
                        <span>{{ userInfo.phone }}</span>
                    </div>
                    <div class="detail">
                        <span>地址：</span>
                        <span>{{ userInfo.address }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="f2">
            <div class="title">
                <span>项目信息</span>
            </div>
            <div class="project">
                <div class="project1" @click="goUpdata('我报名的项目')">
                    <div class="projectImg">
                        <img src="@/assets/img/apply.png" style="width: 100px;height: 100px;">
                    </div>
                    <div class="projectText">
                        <span
                            style="font-size: 22px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #000000;">我的报名项目</span>
                        <div style="display: flex;align-items: center;margin-top: 20px;cursor: pointer;">
                            <span
                                style="font-size: 16px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #616161;">查看我的报名项目</span>
                            <i class="el-icon-arrow-right" style="font-size: 16px;margin-left: 4px;"></i>
                        </div>
                    </div>
                </div>
                <div class="project1" @click="goUpdata('我竞价的项目')">
                    <div class="projectImg">
                        <img src="@/assets/img/bidding.png" style="width: 100px;height: 100px;">
                    </div>
                    <div class="projectText">
                        <span
                            style="font-size: 22px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #000000;">我的竞价项目</span>
                        <div style="display: flex;align-items: center;margin-top: 20px;cursor: pointer;">
                            <span
                                style="font-size: 16px;font-family: Source Han Sans CN-Regular, Source Han Sans CN;font-weight: 400;color: #616161;">查看我的竞价项目</span>
                            <i class="el-icon-arrow-right" style="font-size: 16px;margin-left: 4px;"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getUserInfoByUserId } from "../../api/交易项目详情.js"
export default {
    data () {
        return {
            userInfo: {
            },//用户信息
            cover: require('@/assets/img/user.png')
        }
    },
    methods: {
        goUpdata (str) {
            this.$parent.option = str
        }
    },
    created () {
        getUserInfoByUserId().then(res => {
            this.userInfo = res.data.data ? res.data.data : {
                searchValue: "",
                createBy: "",
                createTime: "",
                updateBy: "",
                updateTime: "",
                remark: "",
                params: {},
                id: "",
                userId: "",
                name: "",
                idcard: "",
                address: "",
                phone: "",
                type: "",
                bankName: "",
                bankCard: "",
                status: "",
                legalPerson: "",
                companyName: "",
                companyType: "",
                registerMoney: "",
                registerNumber: "",
                file: "",
                email: "",
                loginDate: "",
                useStatus: "",
                userName: "",
                sex: "",
                cover: "",
                delFlag: "",
                tenantId: ""
            }
        })
    }
}
</script>

<style scoped>
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

.GRXX {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.f1 {
    /* height: 270px; */
    margin-bottom: 25px;
    box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
    padding: 24px 30px 150px 30px;
    /* padding-bottom: 48px; */
}

.f2 {
    height: auto;
    box-shadow: 0px 0px 25px 4px rgba(90, 90, 90, 0.12);
    padding: 24px 30px 150px 30px;
    /* padding-bottom: 48px; */
}

.title {
    padding-bottom: 20px;
    border-bottom: 1px solid #6681EA;
    display: flex;
    align-items: center;
}

.title>span {
    font-size: 30px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #6681EA;
}

.updata {
    margin: 20px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.updata>.el-icon-arrow-right {
    font-size: 20px;
    color: #6681EA;
}

.info {
    display: flex;
}

.infoCover {
    width: 100px;
    height: 100px;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 50%;
}

.details {
    flex: 1;
    margin-left: 30px;
    display: flex;
    flex-wrap: wrap;
}

.detail {
    display: flex;
    align-items: center;
    width: 33%;
    margin-bottom: 20px;
}

.detail>span {
    font-size: 20px;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #616161;
}

.project {
    display: flex;
    align-items: center;
    margin-top: 20px;
}

.project1 {
    display: flex;
    align-items: center;
    flex: 1;

}

.projectText {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
    cursor: pointer;
}
</style>